<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section
    [title]="t('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PAYMENT_PROCESSING')"
    [level]="1"
    [classes]="'fudis-mt-xxl'">
    <fudis-section-content>
      <fudis-body-text class="fudis-mt-xs">
        {{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PAYMENT_PROCESSING_DESCRIPTION") }}
      </fudis-body-text>
      <fudis-button
        class="fudis-mt-sm"
        [label]="t('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.APPLICATIONS')"
        (handleClick)="goToApplications()"></fudis-button>
    </fudis-section-content>
  </fudis-section>
</ng-container>
